import Image from "./image";

export default class BackgroundImage extends Image {
    
}